import { useCallback, useContext, useEffect, useState } from 'react'
import { MdPerson } from 'react-icons/md'
import Swal from 'sweetalert2'
import { getEmployeesByCompany } from '../../API/Employee/Employee'
import { postCampaign } from '../../API/Services/Campaign/Campaign'
import { EmployerContext } from '../../Store/EmployerContext'
import { campaign } from '../../i18n/translatedMessages'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import './campaign.sass'

import Loading from '../../Components/Loading/Loading'

const Campaign = () => {
	const [selected, setSelected] = useState(false)
	const [employeeList, setEmployeeList] = useState([])
	const [employeesAssigned, setEmployeesAssigned] = useState([])
	const [allAssigned, setAllAssigned] = useState([])
	const [busca, setBusca] = useState('')
	const { store } = useContext(EmployerContext)
	const [isLoadingNew, setIsLoadingNew] = useState(false)
	const [loading, setLoading] = useState(false)

	const load = useCallback(async () => {
		setLoading(true)
		const users = JSON.parse(localStorage.getItem('user'))
		const list = await getEmployeesByCompany(users.id)
		selected ? setEmployeeList(employeeList.filter(item => item.progress !== '100')) : setEmployeeList(list)
		setLoading(false)
	}, [selected])

	useEffect(() => {
		load()
	}, [load])

	const handleChangeAssign = e => {
		const listAux = [...employeesAssigned, e.currentTarget.value]
		if (e.currentTarget.checked) {
			setEmployeesAssigned([...listAux])
		} else {
			const auxEmployeeAssign = listAux.filter(lista => lista !== e.currentTarget.value)
			setEmployeesAssigned(auxEmployeeAssign)
		}
	}

	const alertSend = () => {
		if (employeesAssigned.length === 0) {
			Swal.fire(store.language == 'ES' ? 'Por favor seleccionar un colaborador' : 'Por favor selecionar um colaborador', '', 'warning')
			return
		}

		Swal.fire({
			title:
				store.language == 'ES'
					? 'Confirmar envio de emails a los colaboradores seleccionados'
					: 'Confirme o envio de e-mails para colaboradores selecionados',
			title:
				store.language == 'ES'
					? 'Confirmar envio de emails a los colaboradores seleccionados'
					: 'Confirme o envio de e-mails para colaboradores selecionados',
			showDenyButton: false,
			showCancelButton: true,
			cancelButtonText: 'Cancelar',
			confirmButtonText: 'Enviar',
			confirmButtonColor: '#0AB4C4',
			cancelButtonColor: '#EC6376',
			reverseButtons: true,
		}).then(result => {
			if (result.isConfirmed) {
				handleSendRequests()
			}
		})
		return
	}

	const handleSendRequests = async () => {
		setIsLoadingNew(true)
		const company = JSON.parse(localStorage.getItem('user'))
		const companyID = company.id
		const auxAll = allAssigned.map(allId => Number(allId.employerId))
		const auxEmployeeAssign = employeesAssigned.filter(filt => filt !== undefined && auxAll.indexOf(Number(filt)) < 0)

		const emailListSend = { employersList: auxEmployeeAssign }

		const sendData = await postCampaign(emailListSend, companyID)
		setIsLoadingNew(false)
		unCheck()
		setEmployeesAssigned([])
		sendData.message == 'require sended'
			? Swal.fire(store.language == 'ES' ? 'Enviado con Éxito' : 'Enviado com sucesso', '', 'success')
			: Swal.fire(store.language == 'ES' ? 'Error al enviar emails' : 'Erro ao enviar email', '', 'error')
		sendData.message == 'require sended'
			? Swal.fire(store.language == 'ES' ? 'Enviado con Éxito' : 'Enviado com sucesso', '', 'success')
			: Swal.fire(store.language == 'ES' ? 'Error al enviar emails' : 'Erro ao enviar email', '', 'error')
	}

	const lowerBusca = busca.toLowerCase()

	const employeesListFilt = employeeList.filter(employee => {
		return employee.name.toLowerCase().includes(lowerBusca)
	})

	const unCheck = () => {
		let x = document.getElementsByClassName('assign-custom-checkbox')
		for (const item of x) {
			item.checked = false
		}
	}

	if (loading) return <Loading />

	return (
		<div className='content-campaign'>
			<div className='tw-pr-20'>
				{isLoadingNew && (
					<div className='tw-fixed tw-inset-0 tw-bg-white/50 tw-z-50 tw-flex tw-justify-center tw-items-center'>
						<div className='tw-w-12 tw-h-12 tw-border-4 tw-border-solid tw-border-purple-500 tw-border-t-transparent tw-rounded-full tw-animate-spin'></div>
					</div>
				)}

				<div className='tw-flex tw-items-center tw-gap-3'>
					{/* <MdPerson size={35} /> */}
					<h3 className='tw-mb-4 tw-font-bold'>{campaign.campaignTitle}</h3>
				</div>

				<p className='xl:tw-text-lg tw-text-base tw-mb-4 tw-pr-20'>{campaign.campaignTxt}</p>

				<div className='tw-flex tw-justify-end'>
					<button onClick={alertSend} className='btn-send-campaign tw-cursor-pointer hover:tw-bg-purple-700'>
						Enviar
					</button>
				</div>
			</div>

			<div className='tw-mt-4 tw-pr-20'>
				<div className='tw-w-full tw-max-w-5xl tw-mx-auto'>
					<ul>
						<li className='tw-grid tw-grid-cols-12 tw-text-sm xl:tw-text-base tw-font-semibold tw-text-gray-600 border tw-py-2'>
							<div className='tw-col-span-3 tw-pl-8'>{campaign.campaignTableName}</div>
							<div className='tw-col-span-6'>{campaign.campaignTableMail}</div>
							<div className='tw-col-span-3'>{campaign.campaignTableJob}</div>
						</li>
					</ul>

					{employeeList && employeeList.length > 0 ? (
						<ul className='scrolling'>
							{[...employeeList]
								.sort((a, b) => a.name.localeCompare(b.name))
								.map(employee => (
									<li className='row' key={employee.id}>
										<div className='col-3 ps-1 d-flex align-items-center'>
											<label className='col-3' htmlFor={`checkUser${employee.id}`}>
												<input
													className='assign-custom-checkbox  tw-cursor-pointer'
													name={`checkUser${employee.id}`}
													type='checkbox'
													value={employee.id}
													id={`checkUser${employee.id}`}
													onChange={handleChangeAssign}
												/>
												<span className='checkmark'></span>
											</label>
											{employee.name}
										</div>
										<div className='col-6'>{employee.email}</div>
										<div className='col-3'>{employee.jobName}</div>
									</li>
								))}
						</ul>
					) : (
						<div className='tw-flex tw-justify-center tw-items-center tw-h-[300px] tw-gap-1'>
							No hay colaboradores registrados aún. Haz <Link to='/app/services/new'>clic aquí</Link> para empezar.
						</div>
					)}
				</div>
			</div>
		</div>
	)
}
export default Campaign
